/**
 * 在此文件引入tinymce插件
 */

import Vue from 'vue'
import tinymce from 'tinymce'
import 'tinymce/plugins/link' //链接插件
import 'tinymce/plugins/image' //图片插件
import 'tinymce/plugins/media' //媒体插件
import 'tinymce/plugins/table' //表格插件
import 'tinymce/plugins/lists' //列表插件
import 'tinymce/plugins/quickbars' //快速栏插件
import 'tinymce/plugins/fullscreen' //全屏插件
import 'tinymce/plugins/code' // 代码插件
import 'tinymce/plugins/preview' // 预览插件
import 'tinymce/plugins/print' // 打印插件
import 'tinymce/plugins/help' // 帮助插件
import 'tinymce/plugins/imagetools' // 图片工具插件
import 'tinymce/plugins/wordcount' // 字数统计插件
import 'tinymce/plugins/tabfocus' // tab聚焦插件
import 'tinymce/plugins/save' // 保存插件
import 'tinymce/plugins/paste' // 粘贴插件  
import 'tinymce/plugins/autosave' // 自动保存插件
import 'tinymce/plugins/autolink' // 自动链接插件
import 'tinymce/plugins/searchreplace' // 搜索替换插件
import 'tinymce/plugins/hr' // 水平分割线插件
import 'tinymce/plugins/charmap' // 特殊字符插件
import 'tinymce/plugins/emoticons' // 表情插件
import 'tinymce/plugins/codesample' // 代码示例插件 
import 'tinymce/plugins/directionality' // 文字方向插件
// import 'tinymce/plugins/fullpage' // 文档属性插件 这个插件新增文档会默认增加html信息会引起 文档修改问题
import 'tinymce/plugins/insertdatetime' // 插入当前日期时间插件

Vue.prototype.$tinymce = tinymce // 将全局tinymce对象指向给Vue作用域下